import { policyService } from "@/services/policy.service";
import { RootState } from "@/vuex/types";
import { ActionTree } from "vuex";
import PermissionState from "./permission.types";

type PermissionAcionTree = ActionTree<PermissionState, RootState>;
export const actions: PermissionAcionTree = {
  async getAllPolicies(context) {
    context.commit("setLoading", true);
    const response = await policyService.getPolicyTree();
    context.commit("setPolicies", response);
    context.commit("setLoading", false);
  }
};

export default actions;
